import { Injectable } from '@angular/core';
import { DirectoryRegion } from '@directory-of-directories/domain';
import { BehaviorSubject, map, Observable } from 'rxjs';

export interface DirectoryToolbarState {
  search: string;
  skill_categories: string[];
  sorting: number;
  us: { page: number };
  eu: { page: number };
  currentRegion: DirectoryRegion;
}

@Injectable({ providedIn: 'root' })
export class DirectoryToolbarStateService {
  private readonly _initialState: DirectoryToolbarState = {
    search: '',
    sorting: 0,
    skill_categories: [],
    us: { page: 1 },
    eu: { page: 1 },
    currentRegion: 'US',
  };

  private _state: DirectoryToolbarState = { ...this._initialState };
  private _stateSubject = new BehaviorSubject<DirectoryToolbarState>(this._state);

  readonly urlState$: Observable<DirectoryToolbarState> = this._stateSubject.asObservable();
  readonly currentRegion$ = this.urlState$.pipe(map((s) => s.currentRegion));

  update(partial: Partial<DirectoryToolbarState>, skipPageOverride = false): void {
    if (!skipPageOverride) {
      this.updatePage(1);
    }

    this._state = { ...this._state, ...partial };
    this._stateSubject.next(this._state);
  }

  updatePage(page: number): void {
    const regionKey = this._state.currentRegion === 'US' ? 'us' : 'eu';

    this._state = {
      ...this._state,
      [regionKey]: {
        ...this._state[regionKey],
        page,
      },
    };

    this._stateSubject.next(this._state);
  }

  reset(): void {
    this._state = { ...this._initialState };
    this._stateSubject.next(this._state);
  }
}
